import { Box, Button, Divider, Grid } from '@mui/material';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import WSTextField from '../TextBox/WSTextBox';
import { IsSmallScreen } from '../../commonFunctions/CommonFunctions';
import SearchIcon from '@mui/icons-material/Search';

interface IFilterSearchTextProps {
    rows: IRows;
    onFilterChange: (filters: IFilter[]) => void;
    alignment?: 'left' | 'center' | 'right';
    defaultFilter?: any[]
}

export interface IRows {
    fieldName?: string;
}

interface IFilter {
    field: string;
    operator: Operator | string;
    value: string | number;
}

export enum Operator {
    EqualTo = 'eq',
    NotEqualTo = 'neq',
    GreaterThan = 'gt',
    LessThan = 'lt',
    Like = 'like',
}

export const FilterSearchText: React.FC<IFilterSearchTextProps> = React.memo(({ rows, onFilterChange, alignment = 'left', defaultFilter }) => {
    const methods = useForm();
    const { register, handleSubmit, control, reset } = methods;
    const isMobile = IsSmallScreen();

    const handleReset = () => {
        reset(); // ✅ Correct way to reset form
        onFilterChange([]); // Clear filters
    };

    const onSubmit = (data: Record<string, any>) => {

        if (data.searchAll === undefined) {
            handleReset()
        }
        if (!rows || !rows.fieldName) {
            console.warn("No field names found in rows.");
            return;
        }

        // ✅ Correct usage of `reduce()`
        // const appliedFilters: any[] = (rows.fieldName || []).reduce((acc: any[], field) => {
        //     if (data.searchAll!== "") { // Ensure valid input
        //         acc.push({
        //             field: rows.fieldName,
        //             operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
        //             value: data.searchAll , // ✅ Uses actual field value
        //         });
        //     }
        //     return acc;
        // }, []);
        const appliedFilters: any[] = []
        if (defaultFilter && defaultFilter.length > 0) {
            appliedFilters.push(...defaultFilter)
        }
        if (data.searchAll && data.searchAll !== "") {
            appliedFilters.push({
                field: rows.fieldName,
                operator: Operator.Like, // ✅ Use `Operator.EqualTo` if needed
                value: data.searchAll, // ✅ Uses actual field value
            });
        }
        // console.log("Applied Filters:", appliedFilters);
        onFilterChange(appliedFilters);
    };


    return (
        <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Divider sx={{ marginLeft: 1 }} />

                <Grid container spacing={2} sx={{ margin: 1 }}>

                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            borderRadius: 2,
                            marginTop: 1,
                            height: 45,
                            display: 'flex',
                            alignItems: 'center',
                            px: 1,
                            boxShadow: 1,
                            width: '100%',
                            maxWidth: 300,
                        }}
                    >
                        <Box sx={{ flexGrow: 1 }}>
                            <WSTextField
                                control={control}
                                id="searchAll"
                                size="small"
                                {...register('searchAll')}
                                name="searchAll"
                                label="Search"
                                sx={{ width: '100%',  }}
                            />
                        </Box>

                        <Button
                            variant="contained"
                            color="primary"
                            sx={{
                                minWidth: '45px',
                                height: '36px',
                                ml: 1,
                                px: 2,
                                
                                borderRadius: 2,
                                backgroundColor: '#fff',
                                '&:hover': {
                                    backgroundColor: 'whitesmoke',
                                },
                            }}
                            type='submit'
                        >
                            <SearchIcon sx={{color:'#056e4e'}} />
                        </Button>
                    </Box>


                </Grid>

            </form>
        </FormProvider>
    );
});
